module.exports = __webpack_public_path__ + "static/mstile-310x150-6b46f542cb50eba307bbd8d19ce89f7f.png";